import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, IconButton } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { FC } from 'react';
import clsx from 'clsx';
import { AccountingType } from 'v2-types/order';
import { TFunction } from 'i18next';

const useStyles = makeStyles((theme: any) => ({
  container: { display: 'flex', gap: '4px' },
  btn: {
    fontSize: 16,
    fontWeight: 600,
  },
  edit: {
    color: theme.palette.success.main,
  },
  trash: {
    color: theme.palette.error.main,
  },
}));

type Props = {
  disbursmentItem: AccountingType;
  handleDeleteEntry: (accountingId: string) => void;
  handleConfirmDelete: (
    openConfirm: boolean,
    callback: (() => void) | null,
    title: string,
    confirmationMessage: string
  ) => void;
  t: TFunction;
  handleModals: (modalName: string, idEntry: string) => void;
};

export const DisbursmentsBtns: FC<Props> = ({
  handleDeleteEntry,
  disbursmentItem,
  handleConfirmDelete,
  t,
  handleModals,
}) => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <IconButton
        className={clsx({
          [classes.btn]: true,
          [classes.edit]: true,
        })}
        aria-label={`${t('disbursments:edit')} ${disbursmentItem.description}`}
        onClick={() => handleModals('edit', disbursmentItem._id)}
        disabled={!disbursmentItem.posted}
        size="large"
      >
        <FontAwesomeIcon icon="edit" />
      </IconButton>
      <IconButton
        className={clsx({
          [classes.btn]: true,
          [classes.trash]: true,
        })}
        aria-label={`${t('disbursments:delete')} ${disbursmentItem.description}`}
        onClick={() =>
          handleConfirmDelete(
            true,
            () => handleDeleteEntry(disbursmentItem._id),
            t('disbursments:titleDisbursement'),
            t('disbursments:confirmationMessageDisbursement')
          )}
        size="large"
      >
        <FontAwesomeIcon icon="trash" />
      </IconButton>
    </Box>
  );
};

export default DisbursmentsBtns;
